import { call, put, select, takeLatest, fork, all } from 'redux-saga/effects';
import get from 'lodash.get';
import { format } from 'date-fns';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { SagaIterator } from 'redux-saga';

// @ts-ignore
import { idTokenSelector } from 'services/auth/selectors';
import { updateQueryString } from 'services/router/actions';

import {
    RequestedPayrollExportsPayloadAction,
    RequestedPayrollExportDeleteAction
} from './types';
import {
    PAYROLL_EXPORTS_PAYLOAD_REQUESTED,
    PAYROLL_EXPORT_DELETE_REQUESTED
} from './constants';
import {
    payrollExportsPayloadSucceeded,
    payrollExportsPayloadFailed,
    payrollExportDeleteSucceeded,
    payrollExportDeleteFailed,
    removePayrollExport
} from './actions';
import { selectPayrollExportsKeyedById } from './selectors';

const { REACT_APP_API_URL } = process.env;

export function* payrollExportsPayload(
    action: RequestedPayrollExportsPayloadAction
): SagaIterator {
    const idToken = yield select(idTokenSelector);
    const id = action.payload;
    const url = `${REACT_APP_API_URL}/v1/PayrollExports/${id}/payload`;

    const payrollExports = yield select(selectPayrollExportsKeyedById);
    const createdBy = get(payrollExports, [id, 'createdBy']);
    const createdAt = get(payrollExports, [id, 'createdAt']);

    try {
        const response = yield call(axios, url, {
            method: 'GET',
            headers: {
                'Content-Type': 'text/csv; charset=utf-8',
                Accept: 'text/csv',
                Authorization: idToken
            }
        });

        const date = format(new Date(createdAt), 'yyyyMMdd');

        const filenameSuffix = `_${createdBy
            .replace(/@.+$/, '')
            .replace(/[^0-9a-z]/gi, '')}`;

        // File Download
        fileDownload(response.data, `${date}_${id}${filenameSuffix}.csv`);

        yield put(payrollExportsPayloadSucceeded(response));
    } catch (error) {
        yield put(payrollExportsPayloadFailed(error));
    }
}

export function* deletePayrollExport(
    action: RequestedPayrollExportDeleteAction
): SagaIterator {
    const idToken = yield select(idTokenSelector);
    const id = action.payload;
    const url = `${REACT_APP_API_URL}/v1/Payroll/datacom/${id}`;

    try {
        const response = yield call(axios, url, {
            method: 'delete',
            headers: {
                Authorization: idToken
            }
        });

        yield all([
            put(payrollExportDeleteSucceeded(response)),
            put(
                updateQueryString({
                    selectedPayrollExportId: undefined,
                    timesheetSubmissionsRevertModal: undefined
                })
            ),
            put(removePayrollExport(id))
        ]);
    } catch (error) {
        yield put(payrollExportDeleteFailed(error));
    }
}

export function* watchPayrollExportsPayloadRequested(): SagaIterator {
    yield takeLatest(PAYROLL_EXPORTS_PAYLOAD_REQUESTED, payrollExportsPayload);
}

export function* watchPayrollExportDeleteRequested(): SagaIterator {
    yield takeLatest(PAYROLL_EXPORT_DELETE_REQUESTED, deletePayrollExport);
}

export default function* payrollExportsSagas(): SagaIterator {
    yield all([
        fork(watchPayrollExportsPayloadRequested),
        fork(watchPayrollExportDeleteRequested)
    ]);
}
